import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-10 md:mb-12" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", { class: "mr-4 px-2 pb-2 border-2 border-gray-400 rounded" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-lg" }, "🡨")
], -1)
const _hoisted_3 = {
  key: 2,
  class: "rounded bg-white p-6 md:px-4 flex flex-col md:items-center relative mb-5 md:flex-row justify-center font-bold text-medium"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_spinner = _resolveComponent("spinner")!
  const _component_bulk_parcel_errors_list_item = _resolveComponent("bulk-parcel-errors-list-item")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_DynamicForm = _resolveComponent("DynamicForm")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", null, [
          _createVNode(_component_router_link, { to: { name: 'bulk_parcels.list' } }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["to"]),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("bulk_parcels.errors.title", { id: _ctx.$route.params.id })), 1)
        ])
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_spinner, {
            key: 0,
            class: "mx-auto"
          }))
        : _createCommentVNode("", true),
      (!_ctx.isLoading && _ctx.parcelsWithErrors.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.parcelsWithErrors, (parcel) => {
            return (_openBlock(), _createBlock(_component_bulk_parcel_errors_list_item, {
              parcel: parcel,
              key: parcel.id,
              onEditParcel: _ctx.editParcel
            }, null, 8, ["parcel", "onEditParcel"]))
          }), 128))
        : _createCommentVNode("", true),
      (!_ctx.isLoading && !_ctx.parcelsWithErrors.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.loadFailed ? "general.list_load_error" : "general.empty_list")), 1))
        : _createCommentVNode("", true),
      (_ctx.pagination)
        ? (_openBlock(), _createBlock(_component_pagination, {
            key: 3,
            "total-rows": 20,
            meta: _ctx.pagination,
            onChangePagination: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getList($event.page, $event.perPage)))
          }, null, 8, ["meta"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_modal, {
      modelValue: _ctx.showEditModal,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showEditModal) = $event)),
      "hide-buttons": true
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("parcels.edit.title")), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DynamicForm, {
          formData: _ctx.formData,
          isLoading: _ctx.formLoading,
          initValue: _ctx.formValue,
          initValidation: _ctx.formValidation,
          onCancelAction: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showEditModal = false)),
          onSubmitAction: _ctx.submitAction
        }, null, 8, ["formData", "isLoading", "initValue", "initValidation", "onSubmitAction"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}